import React, { useState } from "react";



import HeroSection from "../components/HeroSection";
import NetworkSection from "../components/NetworkSection";

import bottomBanner from "../../assets/bottomBanner.png"

import dotsPattern from "../../assets/dotsPattern.png";
import circlePattern from "../../assets/circlePattern.png";

import leftArrow from "../../assets/leftArrow.png"
import rightArrow from "../../assets/rightArrow.png"

import slide1 from "../../assets/desktop-slider1.png"
import slide2 from "../../assets/desktop-slider2.png"
import slide3 from "../../assets/desktop-slider3.png"
import slide4 from "../../assets/desktop-slider4.png"

import Slider from "react-slick";

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'


import './homePage.css';

const Homepage = () => {


  const [sliderRef, setSliderRef] = useState(null)
  const settings = {
    // removes default buttons
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  };
  return (
    <div className="homePage">
      

      <HeroSection />

      <NetworkSection />

      <img src={dotsPattern} className = 'dotsPattern'/>
      {/* <img src={circlePattern} className = 'circlePattern'/> */}


      <div className='controls'>
     
     <img src={leftArrow}  className="desktopCaraousePrevButton" onClick={sliderRef?.slickPrev}/>

     <img src={rightArrow} className="desktopCaraouseNextButton" onClick={sliderRef?.slickNext}/>
 

      </div>

      <Slider {...settings} ref={setSliderRef}>

        <div className = 'bottomBanner'>
        <img src={slide1}  style={{width : "100%"}}/>
          </div>   
          <div className = 'bottomBanner'>
        <img src={slide2}  style={{width : "100%"}}/>
          </div>   
          <div className = 'bottomBanner'>
        <img src={slide3}  style={{width : "100%"}}/>
          </div>   
          <div className = 'bottomBanner'>
        <img src={slide4}  style={{width : "100%"}}/>
          </div>   
        </Slider>

  
    </div>
  );
};

export default Homepage;
